import { api as appointmentListApi } from "app/pages/appointment-copy/slice";
import { api as referralListApi } from "app/pages/referral-list/slice";
import { api as signinApi } from "app/pages/signin/slice";
import { api as userProfileApi } from "app/pages/user-profile/slice";
import { api as loginApi } from "app/pages/returning-signin/slice";
import { api as practiceApi } from "app/pages/practice-info/slice";
import { api as reportIssueApi } from "app/pages/report-issue/slice";
import { api as resetPasswordApi } from "app/pages/ResetPassword/slice";
import { api as feedbackApi } from "app/pages/feedbacks/slice";
import { api as otherHelpApi } from "app/pages/other-help/slice";
import { api as globalApi } from "app/slice";
import { api as insightOverviewApi } from "app/pages/insight-overview/slice";

export const rtkQueryMiddleware = [
	appointmentListApi,
	referralListApi,
	signinApi,
	userProfileApi,
	loginApi,
	practiceApi,
	reportIssueApi,
	resetPasswordApi,
	feedbackApi,
	otherHelpApi,
	globalApi,
	insightOverviewApi,
].map(d => d?.middleware);
